import qs from 'qs-lite'

// * methods extending the base server (BE) URL with endpoint addresses (eg. for GQL fetching or user fetching)

// URL params required when fetching guest user info
type TFetchGuestTokenParams = {
  guest: true
}

// URL params required when fetching registered user info
export type TFetchUserTokenParams = {
  password: string
  username: string
}

export type TFetchTokenParams = TFetchGuestTokenParams | TFetchUserTokenParams

export type TResetPasswordParams = {
  ['return_url']: string
  login: string
}

export const getCustomerEndpoint = (serverUrl: string, params: TFetchTokenParams) => {
  return `${serverUrl}/users/customer_token?${qs.stringify(params)}`
}

export const getResetPasswordEndpoint = (serverUrl: string, params: TResetPasswordParams) => {
  return `${serverUrl}/users/reset_customer_password?${qs.stringify(params)}`
}

export const getGqlEndpoint = (serverUrl: string) => `${serverUrl}/graphql`
